var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_book",
    "data-name": "vuesax/bold/book",
    transform: "translate(-556 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.25,2.17V14.06a2.056,2.056,0,0,1-1.76,1.98l-.31.04a25.606,25.606,0,0,0-5.81,1.68A1,1,0,0,1,0,16.83V2.92a1.02,1.02,0,0,1,.54-.89A19.189,19.189,0,0,1,7.02,0h.06A2.168,2.168,0,0,1,9.25,2.17Z",
    transform: "translate(568.75 190.68)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.72,2.03A19.189,19.189,0,0,0,2.24,0H2.17A2.168,2.168,0,0,0,0,2.17V14.06a2.056,2.056,0,0,0,1.76,1.98l.31.04a25.606,25.606,0,0,1,5.81,1.68,1,1,0,0,0,1.37-.93V2.92A1,1,0,0,0,8.72,2.03ZM3.01,5.06H5.26a.75.75,0,0,1,0,1.5H3.01a.75.75,0,0,1,0-1.5Zm3,4.5h-3a.75.75,0,0,1,0-1.5h3a.75.75,0,0,1,0,1.5Z",
    transform: "translate(557.99 190.68)",
    fill: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(580 212) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLibrary);
export default __webpack_public_path__ + "static/media/menu_library.3ea6baa0522daa86aae447611e250393.svg";
export { ForwardRef as ReactComponent };